export const ACTIVE_VIEW_STATE_LOBBY = 'ACTIVE_VIEW_STATE_LOBBY'
export const ACTIVE_VIEW_STATE_MIXER = 'ACTIVE_VIEW_STATE_MIXER'
export const ACTIVE_VIEW_STATE_VIDEO = 'ACTIVE_VIEW_STATE_VIDEO'
